export const USER_EXTRACTOR_KEYS = {
    GROUPS: "groups",
    PROGRAMS: "programs",
    DIRECT_CONTROL_ASSIGNMENTS: "directControlAssignments",
    PENDING_ACTIVITIES: "pendingActivities",
    TESTING_CONTROL_ASSIGNMENTS: "testingControls",
    TESTING_PROGRAMS: "testingPrograms",
    PENDING_TESTING_ACTIVITIES: "testingActivities",
    REPORTS: "reports",
    RISK_MANAGEMENT: "riskManagement",
    ROLES: "roles",
    NAME: "name",
    LOGIN_WITH_PASSWORD: "loginWithPassword",
    EMAIL: "email",
    PROVISION_STATUS: "provisionStatus",
} as const;
